export const namespace = "tutorial/";
export const SET_SLIDE = "SET_SLIDE";
